import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsMarandoServiceNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "5034c47d-34ab-4f4f-a024-08aa1cbe7b90";
  }
  return false;
};
